<script>
  import { createEventDispatcher, onMount } from "svelte";
  import { scale } from "svelte/transition";
  import * as PHE from "print-html-element";
  import config from "../../stores/config";
  import axios from "axios";

  export let show = false;

  // ---------------------------------------------------------------------
  export let _id;
  export let jobType;

  // ALL DEPARTMENTS -----------------------------------------------------
  export let customerID;
  export let orderID;
  export let delDate;

  // CABINETRY DEPARTMENT + MACHINE DEPARTMENT ---------------------------
  export let department;
  export let departmentTask;
  export let sprayPaint;

  // MACHINE DEPARTMENT --------------------------------------------------
  export let foam;
  export let assembly;

  // MACHINIST -----------------------------------------------------------
  export let machinist;
  export let description;
  export let framing;
  export let upholsterer;
  export let quality;
  export let fabricInfo;
  export let notes;
  export let repFoaming;
  export let meterage;
  export let cutter;
  export let cushions;

  export let framingFN;
  export let foamingFN;
  export let fabricInfoFN;
  export let cushionsFN;
  export let cutterFN;
  export let meterigeFN;
  export let qualityFN;

  // -------------------------
  let customer;
  let graphic, photo, graphic2, photo2;

  const handlePrint = () => {
    PHE.printElement(document.getElementById("invoice-area"));
  };

  const dispatch = createEventDispatcher();

  let JOB_N;
  let CUSTOMER_ID;

  onMount(async () => {
    let res;
    res = await axios.get(`${$config.backendURL}/orders/${orderID}`);

    JOB_N = res.data.orderID;
    CUSTOMER_ID = res.data.customerID;

    res = await axios.get(`${$config.backendURL}/customers/${CUSTOMER_ID}`);
    customer = res.data;

    res = await axios.get(`${$config.backendURL}/fstyles/${_id}`);

    graphic = res.data.graphic;
    photo = res.data.photo;
    graphic2 = res.data.graphic2;
    photo2 = res.data.photo2;
  });
</script>

{#if show}
  <!-- content here -->
  <div
    transition:scale
    class="px-6 py-6 fixed top-0 left-0 bottom-0 right-0 flex items-center justify-center overflow-y-auto"
    style="z-index: 1500;  background-color: rgba(0, 0, 0, .75)"
    on:click|self={() => dispatch("close")}
  >
    <div
      class="py-1 px-8 absolute top-0 left-0 right-0 flex items-center justify-center"
    >
      <button
        class="btn btn-red"
        style="padding: .75rem 4rem !important;"
        on:click={handlePrint}
      >
        <i class="fas fa-print mr-3 text-xl" />
        PRINT JOB CARD
      </button>
      <button
        class="btn btn-secondary ml-8"
        style="padding: .75rem 4rem !important;"
        on:click={() => dispatch("close")}
      >
        <i class="fas fa-times-circle mr-3 text-xl" />
        CLOSE
      </button>
    </div>

    <div class="A4 py-4 px-10 text-sm overflow-auto bg-white" id="invoice-area">
      <!--  -->
      <div class="flex items-center mb-4">
        <img src="./favicon-rect.png" class="h-10" alt="" />
        <div class="text-xl w-full text-center -ml-20">JOB CARD</div>
      </div>
      <!--  -->

      <!-- ROW 1: FIELDS SCOPE: EVERYONE -->
      <div class="grid grid-cols-3">
        <div class="bdr">CUST: {customer?.fullName}</div>
        <div class="bdr">JOB NO: {JOB_N}</div>
        <div class="bdr">
          DEL DATE: {new Date(delDate)?.toDateString()?.slice(4)}
        </div>
      </div>

      <!-- ROW 2: FIELDS SCOPE: CABINET -->
      {#if jobType == "1"}
        <div class="grid grid-cols-3">
          <!-- INFOS -->
          <div>
            <!-- <div class="bdr hdr">{department}:</div> -->
            <div class="bdr hdr h-8" />
            <div class="bdr minh">
              {@html departmentTask?.replaceAll("\n", "<div/>")}
            </div>

            <div class="bdr hdr">SPRAY/PAINT:</div>
            <div class="bdr minh">
              {@html sprayPaint?.replaceAll("\n", "<div/>")}
            </div>
          </div>

          <!-- IMAGE -->
          <div class="bdr col-span-2 grid grid-cols-2 gap-4">
            {#if graphic2 || photo2}
              {#if photo2}
                <img class="w-84 mr-4" src={photo2} alt="wait" />
              {/if}
              {#if graphic2}
                <img class="w-84" src={graphic2} alt="wait" />
              {/if}
            {:else}
              {#if photo}
                <img class="w-84 mr-4" src={photo} alt="wait" />
              {/if}
              {#if graphic}
                <img class="w-84" src={graphic} alt="wait" />
              {/if}
            {/if}
          </div>
        </div>
      {/if}

      <!-- ROW 3: FIELDS SCOPE:  MACHINE -->
      {#if jobType == "2"}
        <div class="grid grid-cols-3">
          <!-- INFOS -->
          <div class="flex flex-col">
            <!-- <div class="bdr hdr">{department}:</div> -->
            <div class="bdr hdr h-8" />
            <div class="bdr minh">
              {@html departmentTask?.replaceAll("\n", "<div/>")}
            </div>

            <div class="bdr hdr">ASSEMBELY:</div>
            <div class="bdr minh h-full">
              {@html assembly?.replaceAll("\n", "<div/>")}
            </div>
          </div>

          <!-- IMAGE -->
          <div class="col-span-2 grid grid-cols-2">
            <div class="col-span-2 grid grid-cols-2">
              <div class="bdr hdr" />
              <!-- <div class="bdr hdr">FOAM:</div> -->
              <div class="bdr hdr">SPRAY/PAINT:</div>
              <div class="bdr minh">
                {@html foam?.replaceAll("\n", "<div/>")}
              </div>
              <div class="bdr minh">
                {@html sprayPaint?.replaceAll("\n", "<div/>")}
              </div>
            </div>

            <div class="col-span-2 bdr">
              <div class="grid grid-cols-2 gap-4">
                {#if graphic2 || photo2}
                  {#if photo2}
                    <img class="w-84 mr-4" src={photo2} alt="wait" />
                  {/if}
                  {#if graphic2}
                    <img class="w-84" src={graphic2} alt="wait" />
                  {/if}
                {:else}
                  {#if photo}
                    <img class="w-84 mr-4" src={photo} alt="wait" />
                  {/if}
                  {#if graphic}
                    <img class="w-84" src={graphic} alt="wait" />
                  {/if}
                {/if}
              </div>
            </div>
          </div>
        </div>
      {/if}

      <!-- ROW 4: FIELDS SCOPE:  MACHINIST -->
      {#if jobType == "3"}
        <div class="grid grid-cols-3">
          <!-- INFOS -->
          <div class="col-span-2">
            <div class="bdr hdr">MACHINIST: {machinist}</div>
          </div>
          <div class="">
            <div class="bdr hdr">UPHOSTERER: {upholsterer}</div>
          </div>

          <!-- INFOS -->
          <div class="bdr hdr">DESCRIPTION:</div>
          <div class="bdr hdr">QUALITY: {qualityFN}</div>
          <div class="bdr hdr">FRAMING: {framingFN}</div>

          <div class="bdr minh">
            {@html description?.replaceAll("\n", "<div/>")}
          </div>
          <div class="bdr minh">
            {@html quality?.replaceAll("\n", "<div/>")}
          </div>
          <div class="bdr minh h-full">
            {@html framing?.replaceAll("\n", "<div/>")}
          </div>

          <div class="">
            <div class="bdr hdr">FABRIC INFO: {fabricInfoFN}</div>
            <div class="bdr minh">
              {@html fabricInfo?.replaceAll("\n", "<div/>")}
            </div>
            <div class="bdr hdr">METERAGE: {meterigeFN}</div>
            <div class="bdr minh">
              {@html meterage?.replaceAll("\n", "<div/>")}
            </div>
            <div class="bdr hdr">CUTTER: {cutterFN}</div>
            <div class="bdr minh">
              {@html cutter?.replaceAll("\n", "<div/>")}
            </div>
            <div class="bdr hdr">CUSHIONS: {cushionsFN}</div>
            <div class="bdr minh">
              {@html cushions?.replaceAll("\n", "<div/>")}
            </div>
          </div>

          <!-- IMAGE -->
          <div class="col-span-2 grid grid-cols-2">
            <div class="flex flex-col">
              <div class="bdr hdr">ADDITIONAL NOTES:</div>
              <div class="bdr minh h-full">
                {@html notes?.replaceAll("\n", "<div/>")}
              </div>
            </div>

            <div class="flex flex-col">
              <div class="bdr hdr">REP/FOAMING: {foamingFN}</div>
              <div class="bdr minh h-full">
                {@html repFoaming?.replaceAll("\n", "<div/>")}
              </div>
            </div>

            <div class="col-span-2 bdr">
              <div class="grid grid-cols-2 gap-4">
                {#if graphic2 || photo2}
                  {#if photo2}
                    <img class="w-84 mr-4" src={photo2} alt="wait" />
                  {/if}
                  {#if graphic2}
                    <img class="w-84" src={graphic2} alt="wait" />
                  {/if}
                {:else}
                  {#if photo}
                    <img class="w-84 mr-4" src={photo} alt="wait" />
                  {/if}
                  {#if graphic}
                    <img class="w-84" src={graphic} alt="wait" />
                  {/if}
                {/if}
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  </div>
{/if}

<style>
  .A4 {
    width: 90vw;
    height: 90vh;
    /* height: 2480px; */
    /* width: 3508px; */
  }

  .bdr {
    box-sizing: border-box;
    border: 1px solid rgba(31, 41, 55, 0.15);
    margin: 1px 1px;
    padding: 0.25rem 0.5rem;
  }

  .hdr {
    color: #333;
    background-color: rgb(31, 41, 55, 0.05);
    font-weight: bold;
  }

  .minh {
    min-height: 5rem;
  }
</style>
